import * as React from 'react';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

import { cn } from 'utils/shadcn';

import { Flex } from './layout';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    className?: string;
    showCheck?: boolean;
    id?: string;
    label?: string;
    labelClassName?: string;
  }
>(
  (
    { className, showCheck = true, id, label, labelClassName, ...props },
    ref
  ) => {
    const generatedId = React.useId();
    const checkboxId = id || generatedId;

    return (
      <Flex align='center' gap='sm'>
        <CheckboxPrimitive.Root
          ref={ref}
          id={checkboxId}
          className={cn(
            'peer h-4 w-4 shrink-0 cursor-pointer rounded-sm bg-neutral-50 border border-neutral-900 ring-offset-neutral-50',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-900 focus-visible:ring-offset-2',
            'disabled:cursor-not-allowed disabled:bg-neutral-input-disabled-bg disabled:border-neutral-input-disabled-border disabled:text-neutral-input-disabled-text',
            'data-[state=checked]:bg-neutral-900 data-[state=checked]:text-neutral-50 [&_svg]:!stroke-neutral-50',
            className
          )}
          {...props}
        >
          <CheckboxPrimitive.Indicator
            className={cn('flex items-center justify-center text-current')}
          >
            {showCheck && <Check className='h-4 w-4' />}
          </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>

        {label && (
          <label
            htmlFor={checkboxId}
            className={cn('cursor-pointer text-neutral-900', labelClassName)}
          >
            {label}
          </label>
        )}
      </Flex>
    );
  }
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
